module.exports = new __parcel__URL__("GitLab.af604b0d.svg").toString();